import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';

export default class LinkTextBoxViewModel extends ControlViewModel {

    /**
     * Das ViewModel für die TextBox
     */
    public textBox: TextBoxViewModel;

    /**
     * Das ViewModel für den Link
     */
    public link: LinkViewModel;

    /**
     * Das ViewModel für den Link
     */
    public linkChange: LinkViewModel;

    /**
     * Das ViewModel für die LinkTextBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.textBox = this.paramOrDefault(params.textBox, null);
        this.link = this.paramOrDefault(params.link, null);
        this.linkChange = this.paramOrDefault(params.linkChange, null);
    }
}

ComponentManager.setViewModel('LinkTextBoxViewModel', LinkTextBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');